import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeRedeem } from 'src/shared/models/redeemResource.model';

const {
  REDEEM_PRODUCT_BUTTON,
  REDEEM_PRODUCT_TERMS_LINK,
  REDEEM_PRODUCT_TERMS_TEXT,
  REDEEM_PRODUCT_DESCRIPTION,
} = ResourceTypeDetailEnum;

export const buildChallengeRedeemProduct = (
  resource: IResourceList
): IChallengeRedeem => {
  const { resourceDetailList, idResource, name: title, score } = resource;
  let item: IChallengeRedeem;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case REDEEM_PRODUCT_BUTTON:
          item = {
            ...item,
            buttonText: value,
          };
          break;
        case REDEEM_PRODUCT_TERMS_LINK:
          item = {
            ...item,
            termsLink: value,
          };
          break;
        case REDEEM_PRODUCT_TERMS_TEXT:
          item = {
            ...item,
            termsText: value,
          };
          break;
        case REDEEM_PRODUCT_DESCRIPTION:
          item = {
            ...item,
            descriptionText: value,
          };
          break;
        default:
          break;
      }
    });

  return {
    ...item,
    idResource,
    points: score?.points || 0,
    title,
  };
};
